module.exports = __webpack_public_path__ + "static/shape_bg-49d71d788158faa35d0c5d65f17c808b.png";